export default __webpack_public_path__ + "static/media/PaymentEmpty.b0d61d56.svg";